import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { success } from "../Global/toast";
import clsx from "clsx";
import APICallService from "../api/apiCallService";
import { CONTACTUS, FAQ } from "../api/apiEndPoints";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Main_img from "../assets/media/main-img.webp";
import GooglePlaySVG from "../assets/media/google-play.svg";
import AppStoreSvg from "../assets/media/app-store.svg";
import StarIcon from "../assets/media/star.svg";
import ChatIcon from "../assets/media/contact.svg";
import Mail from "../assets/media/mail.svg";
import LaurenM from "../assets/media/testimonials/lauren-m.webp";
import wearable from "../assets/media/Support.svg";
import progress from "../assets/media/progress.svg";
import medication from "../assets/media/medication.svg";
import logger from "../assets/media/logger.svg";
import intake from "../assets/media/intake.svg";
import calory from "../assets/media/calory.svg";
import cycle from "../assets/media/cycle.svg";

export const FeaturesData = [
    {
        id: 0,
        img: intake,
        title: "Daily Calorie Goal",
        subtitle: "Calculated for each cycle based on your personal information and adapted daily based on your inputs.",
    },
    {
        id: 1,
        img: calory,
        title: "Daily Tracking",
        subtitle: "Log total calories consumed, exercise and symptoms each day.",
    },
    {
        id: 2,
        img: cycle,
        title: "Cycle Insights",
        subtitle:
            "Tune into each phase of your cycle to gain insights into your personal rhythm.",
    },
    {
        id: 3,
        img: progress,
        title: "Weight Progress",
        subtitle:
            "Log weigh-ins, view estimated weight loss, and track progress across current and previous cycles.",
    },
    {
        id: 4,
        img: medication,
        title: "Medication Reminder",
        subtitle: "Add medicines with dosage, interval, frequency, reminder time, snooze, and custom notification text.",
    },
    {
        id: 5,
        img: wearable,
        title: "Health App Integration",
        subtitle: "Link your health apps to automatically integrate your data.",
    },
    {
        id: 6,
        img: progress,
        title: "Customisable Dashboard",
        subtitle: "Personalise your home screen with the data you want to see daily.",
    },
    {
        id: 7,
        img: logger,
        title: "Changeable Colour Theme",
        colors: ["#9CA47F", "#E78FAB", "#CAB49A"]
    }
];
// export const howItWorksSlides = [
//     {
//         id: 1,
//         image: HowWork1,
//         title: "Post your job",
//         desc: "Easily schedule your pickup and drop-off with just a few taps!",
//     },
//     {
//         id: 2,
//         image: HowWork2,
//         title: "Hitch finds a verified driver already going your way.",
//         desc: "Connect instantly with verified drivers traveling the same way.",
//     },
//     {
//         id: 3,
//         image: HowWork3,
//         title: "Receive offers and negotiate via In-App Chat.",
//         desc: "Get instant offers from verified drivers.Chat directly to negotiate and confirm your ride.",
//     },
//     {
//         id: 4,
//         image: HowWork4,
//         title: "Agree & Confirm details",
//         desc: "Double-check pickup, drop-off, and fare.Confirm when everything looks good.",
//     },
//     {
//         id: 5,
//         image: HowWork5,
//         title: "Track and pay securely in the app",
//         desc: "Real-time tracking, hassle-free payments.Everything you need — all in one app.",
//     },
// ];
export const HowItWorksData = [
    {
        id: 1,
        title: "Create your profile",
        subtitle: "Enter your date of birth, height and weight.",
    },
    {
        id: 2,
        title: "Choose your subscription",
        subtitle: "Pick from a free one-cycle trial, weekly, monthly, or yearly plan to unlock full access.",
    },
    {
        id: 3,
        title: "Set your cycle goal",
        subtitle: "Choose to either lose weight or maintain and enter your cycle details.",
    },
    {
        id: 4,
        title: "Track daily",
        subtitle: "Open the Today screen to see your calorie goal, log your intake, exercise, symptoms, and monitor your progress this cycle.",
    },
];
export const PricingData = [
    {
        id: 1,
        title: "Free trial",
        subtitle: "One period cycle",
        features: ["Full app access", "One cycle duration", "Daily calorie goals", "Cycle & progress tracking"],
        isHighlighted: false,
    },
    {
        id: 2,
        title: "Weekly",
        subtitle: "Billed weekly",
        features: ["Full app access", "All features included", "Manage anytime", "Cancel anytime"],
        isHighlighted: false,
    },
    {
        id: 3,
        title: "Monthly",
        subtitle: "Billed monthly",
        features: ["Full app access", "All features included", "Manage anytime", "Cancel anytime"],
        isHighlighted: false,
    },
    {
        id: 4,
        title: "Yearly",
        subtitle: "Billed annually",
        badge: "Best Value",
        features: ["Full app access", "All features included", "Best value plan", "Cancel anytime"],
        isHighlighted: true,
    },
];
export const TestimonialData = [
    {
        name: "Lauren M.",
        rating: 5,
        image: LaurenM,
        review: "FeedMyCycle completely changed how I approach my routine. Before, I never understood why my energy and cravings kept shifting every week.",
    },
    {
        name: "Saoirse B.",
        rating: 3,
        image: LaurenM,
        review: "I started using FeedMyCycle out of curiosity, but it quickly became part of my daily routine. It helped me understand what my body needs during each phase.",
    },
];
interface FormData {
    name: string;
    email: string;
    message: string;
}
interface validationErrors {
    name: boolean;
    email: boolean;
    message: boolean;
}
interface FAQItem {
    _id: string;
    question: string;
    answer: string;
}
const Home = () => {
    const location = useLocation();

    const initialState = {
        name: "",
        email: "",
        message: "",
    };

    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState<FormData | any>(initialState);
    const [faqs, setFaqs] = useState<FAQItem[]>([]);
    const [faqLoading, setFaqLoading] = useState(true);
    const faqFetchedRef = useRef(false);
    // const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);
    // const recaptchaRef = useRef<HTMLDivElement>(null);
    // const recaptchaWidgetId = useRef<number | null>(null);
    // const recaptchaRenderedRef = useRef<boolean>(false);

    const [validationErrors, setValidationErrors] = useState<validationErrors>({
        name: false,
        email: false,
        message: false,
    });

    const [selectedPlan, setSelectedPlan] = useState<number>(PricingData.find(plan => plan.isHighlighted)?.id || 1);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handleScrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
        e.preventDefault();

        if (location.pathname !== "/") {
            window.location.href = `/#${sectionId}`;
        } else {
            // Smooth scroll to section
            const element = document.getElementById(sectionId);
            if (element) {
                const headerOffset = 0;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        }
    };

    useEffect(() => {
        setValidationErrors({
            name: false,
            email: false,
            message: false,
        });
    }, [location.pathname]);

    // useEffect(() => {
    //     (window as any).onRecaptchaSuccess = (token: string) => {
    //         setRecaptchaToken(token);
    //     };

    //     (window as any).onRecaptchaError = () => {
    //         setRecaptchaToken(null);
    //     };

    //     (window as any).onRecaptchaExpired = () => {
    //         setRecaptchaToken(null);
    //     };

    //     const renderRecaptcha = () => {
    //         if (recaptchaRenderedRef.current) {
    //             return;
    //         }
    //         if (recaptchaRef.current && (window as any).grecaptcha && (window as any).grecaptcha.render) {
    //             if (recaptchaWidgetId.current !== null) {
    //                 return;
    //             }
    //             if (recaptchaRef.current.children.length > 0) {
    //                 recaptchaRenderedRef.current = true;
    //                 return;
    //             }
    //             try {
    //                 recaptchaWidgetId.current = (window as any).grecaptcha.render(recaptchaRef.current, {
    //                     sitekey: "6Lemrh8sAAAAALg4miyU4pczrrhZEKpxQnfYeOr-",
    //                     // size: "compact",
    //                     callback: (token: string) => {
    //                         setRecaptchaToken(token);
    //                     },
    //                     "expired-callback": () => {
    //                         setRecaptchaToken(null);
    //                     },
    //                     "error-callback": () => {
    //                         setRecaptchaToken(null);
    //                     },
    //                 });
    //                 recaptchaRenderedRef.current = true;
    //             } catch (error) {
    //                 console.error("Error rendering reCAPTCHA:", error);
    //             }
    //         }
    //     };

    //     if ((window as any).grecaptcha && (window as any).grecaptcha.render) {
    //         renderRecaptcha();
    //     } else {
    //         const checkRecaptcha = setInterval(() => {
    //             if ((window as any).grecaptcha && (window as any).grecaptcha.render) {
    //                 clearInterval(checkRecaptcha);
    //                 renderRecaptcha();
    //             }
    //         }, 100);
    //         setTimeout(() => {
    //             clearInterval(checkRecaptcha);
    //         }, 10000);
    //     }

    //     return () => {
    //         if (recaptchaWidgetId.current !== null && (window as any).grecaptcha) {
    //             try {
    //                 (window as any).grecaptcha.reset(recaptchaWidgetId.current);
    //             } catch (e) { }
    //         }
    //         delete (window as any).onRecaptchaSuccess;
    //         delete (window as any).onRecaptchaError;
    //         delete (window as any).onRecaptchaExpired;
    //     };
    // }, []);

    useEffect(() => {
        if (faqFetchedRef.current) return;

        const fetchFAQs = async () => {
            try {
                faqFetchedRef.current = true;
                setFaqLoading(true);
                const apiService = new APICallService(FAQ, {});
                const response = await apiService.callAPI();

                if (response) {
                    let parsedResponse = response;
                    if (typeof response === "string") {
                        try {
                            parsedResponse = JSON.parse(response);
                        } catch (e) {
                            return;
                        }
                    }

                    const records = parsedResponse.records || [];

                    if (Array.isArray(records)) {
                        setFaqs(records);
                    }
                }
            } catch (error) {
                faqFetchedRef.current = false;
                console.error("FAQ API Error:", error);
            } finally {
                setFaqLoading(false);
            }
        };

        fetchFAQs();
    }, []);

    const handleInputChange = (value: string, field: keyof FormData) => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        const nameRegex = /^[a-zA-Z\s]+$/;

        let isInvalid = false;
        if (field === "name") {
            isInvalid = value.trim().length === 0 || !nameRegex.test(value.trim());
        } else if (field === "email") {
            isInvalid = value.trim().length === 0 || !emailRegex.test(value.trim());
        } else {
            isInvalid = value.trim().length === 0;
        }

        setValidationErrors((prev) => ({
            ...prev,
            [field]: isInvalid,
        }));

        setFormData((prev: FormData) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            const { name, email, message } = formData;
            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            const nameRegex = /^[a-zA-Z\s]+$/;

            const errors: validationErrors = {
                name: name.trim().length === 0 || !nameRegex.test(name.trim()),
                email: !emailRegex.test(email.trim()),
                message: message.trim().length === 0,
            };

            setValidationErrors(errors);

            const isValid = Object.values(errors).every((error) => !error);

            if (!isValid) return;

            // if (!recaptchaToken) {
            //     error("Please complete the reCAPTCHA verification.");
            //     return;
            // }

            setLoading(true);
            const apiService = new APICallService(CONTACTUS, {
                ...formData
            });
            const response = await apiService.callAPI();

            if (response) {
                setFormData({
                    name: "",
                    email: "",
                    message: "",
                });
                setValidationErrors({
                    name: false,
                    email: false,
                    message: false,
                });
                // setRecaptchaToken(null);
                // if (recaptchaWidgetId.current !== null && (window as any).grecaptcha) {
                //     try {
                //         (window as any).grecaptcha.reset(recaptchaWidgetId.current);
                //     } catch (e) { }
                // }
                success("Contact details submitted successfully!");
            }
        } catch (err) {
            console.error("Submission error:", err);
        } finally {
            setLoading(false);
        }
    };

    const renderFAQItems = (faqsList: FAQItem[], accordionId: string) => {
        if (faqLoading) {
            return <div className="text-center p-5">Loading FAQs...</div>;
        }

        if (faqsList.length === 0) {
            return <div className="text-center p-5">No FAQs available.</div>;
        }

        return faqsList.map((faq, index) => {
            const itemNumber = String(index + 1).padStart(2, "0");
            const headingId = `accordion-heading-${accordionId}-${index + 1}`;
            const collapseId = `accordion-collapse-${accordionId}-${index + 1}`;
            const isFirstItem = index === 0;
            const uniqueKey = `${accordionId}-${faq._id}-${index}`;

            return (
                <div key={uniqueKey} className="card accordion-item">
                    <div className="card-header d-flex align-items-center gap-5" id={headingId}>
                        <p className="fs-18 fw-normal text-secondary mb-0">{itemNumber}</p>
                        <button
                            className={isFirstItem ? "" : "collapsed"}
                            data-bs-toggle="collapse"
                            data-bs-target={`#${collapseId}`}
                            aria-expanded={isFirstItem ? "true" : "false"}
                            aria-controls={collapseId}
                        >
                            {faq.question}
                        </button>
                    </div>
                    <div
                        id={collapseId}
                        className={`collapse ${isFirstItem ? "show" : ""}`}
                        aria-labelledby={headingId}
                        data-bs-parent={`#accordion-${accordionId}`}
                    >
                        <div className="card-body ps-lg-13">
                            <div className="fs-18 fw-medium mb-0" dangerouslySetInnerHTML={{ __html: faq.answer }} />
                        </div>
                    </div>
                </div>
            );
        });
    };

    return (
        <>
            <div id="home" className="main-hero-sec wrapper overflow-hidden bg-soft-primary">
                <div className="container pt-10 pt-lg-6 pb-10 pb-lg-13">
                    <div className="row gy-10 align-items-center">
                        <div className="col-lg-6 text-center text-lg-start">
                            <div className="">
                                <h1 className="fs-46 fw-bolder text-capitalize text-mine-shaft mb-6 main-ease-animator1">
                                    Lose weight in sync with your menstrual cycle.
                                </h1>
                                <p className="fs-20 fw-medium text-mine-shaft mb-8 main-ease-animator2">
                                    Welcome to FeedMyCycle, a calorie tracking weight loss tool designed to help you lose weight by eating intuitively with your period cycle.
                                </p>
                                <div className="d-flex flex-wrap justify-content-center justify-content-lg-start gap-3 gap-md-4">
                                    <div>
                                        <Link to="#">
                                            <img
                                                className="img-fluid main-ease-animator3"
                                                src={GooglePlaySVG}
                                                width={177}
                                                height={55}
                                                alt="Google Play"
                                            />
                                        </Link>
                                        <p className="ms-4 main-ease-animator3 text-primary text-lg-start text-mine-shaft mt-3 mb-0 fs-18 fw-bolder">
                                            Coming Soon...
                                        </p>
                                    </div>
                                    <div>
                                        <Link to="#">
                                            <img
                                                className="img-fluid main-ease-animator3"
                                                src={AppStoreSvg}
                                                width={165}
                                                height={55}
                                                alt="App store"
                                            />
                                        </Link>
                                        <p className="ms-4 main-ease-animator3 text-primary text-lg-start text-mine-shaft mt-3 mb-0 fs-18 fw-bolder">
                                            Coming Soon...
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 text-center">
                            <img
                                src={Main_img}
                                className="img-fluid main-ease-animator1"
                                width="569"
                                height="569"
                                alt=""
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="wrapper section-padding bg-zircon" id="what-it-tracks">
                <div className="container">

                    {/* TEXT CONTENT */}
                    <div className="row mb-8 mb-lg-10">
                        <div className="col-lg-10 col-xl-9">
                            <span className="bg-primary text-white fs-20 fw-bold text-uppercase px-3 py-1 d-inline-block rounded mb-3">
                                What It Tracks
                            </span>

                            <h2 className="fw-bolder text-mine-shaft fs-50">
                                Your cycle has four phases.<br />
                                Your nutrition should too
                            </h2>

                            <p className="fs-20 fw-medium text-mine-shaft mb-0">
                                Not every day of your cycle is the same - some days you're full of energy and motivated while other days bring lower energy, cravings and hunger.<br/><br/>
                                Our cycle-based approach provides you with a daily calorie goal that adapts to each day and stage of your cycle, allowing flexibility when needed, with daily calorie adjustments so that you still reach your cycle weight loss goal.
                            </p>
                        </div>
                    </div>

                    {/* FULL WIDTH CARDS */}
                    <div className="row g-3 g-md-4">

                        {/* CARD 1 */}
                        <div className="col-6 col-md-3">
                            <div className="phase-card phase-card-1 d-flex flex-column justify-content-center p-4 p-lg-5">
                                <h4 className="fw-bold mb-2 fs-18 fs-md-22">
                                    Menstrual
                                </h4>
                                <p className="mb-0 fw-medium fs-14">
                                    Phase 1
                                </p>
                            </div>
                        </div>

                        {/* CARD 2 */}
                        <div className="col-6 col-md-3">
                            <div className="phase-card phase-card-2 d-flex flex-column justify-content-center p-4 p-lg-5">
                                <h4 className="fw-bold mb-2 fs-18 fs-md-22">
                                    Follicular
                                </h4>
                                <p className="mb-0 fw-medium fs-14">
                                    Phase 2
                                </p>
                            </div>
                        </div>

                        {/* CARD 3 */}
                        <div className="col-6 col-md-3">
                            <div className="phase-card phase-card-3 d-flex flex-column justify-content-center p-4 p-lg-5">
                                <h4 className="fw-bold mb-2 fs-18 fs-md-22">
                                    Ovulation
                                </h4>
                                <p className="mb-0 fw-medium fs-14">
                                    Phase 3
                                </p>
                            </div>
                        </div>

                        {/* CARD 4 */}
                        <div className="col-6 col-md-3">
                            <div className="phase-card phase-card-4 d-flex flex-column justify-content-center p-4 p-lg-5">
                                <h4 className="fw-bold mb-2 fs-18 fs-md-22">
                                    Luteal
                                </h4>
                                <p className="mb-0 fw-medium fs-14">
                                    Phase 4
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="features" className="wrapper section-padding bg-soft-primary">
                <div className="container">
                    <h2 className="fs-50 fw-bolder text-center mb-2 main-ease-animator1">Features</h2>
                    <p className="fs-30 fw-medium text-center mb-10 mb-lg-12">
                        Intelligent Insights.
                    </p>
                    <div className="row gy-4 gy-lg-12 gx-lg-10">
                        {FeaturesData.map((item) => (
                            <div key={item.id} className="col-md-6 col-xl-4 d-flex">
                                <div className="card br-20 align-items-center w-100">
                                    <div className="card-body text-center p-lg-10 ">
                                        <img
                                            alt={item.title}
                                            src={item.img}
                                            className="img-fluid mb-5 mb-lg-7"
                                            width="82"
                                            height="82"
                                            loading="lazy"
                                        />

                                        <h3 className="fs-34 fw-bolder mb-4 mb-lg-5 px-lg-4">{item.title}</h3>

                                        {item.colors ? (
                                            <div className="d-flex justify-content-center gap-3">
                                                {item.colors.map((color, index) => (
                                                    <div
                                                        key={index}
                                                        className="shadow-sm"
                                                        style={{
                                                            backgroundColor: color,
                                                            width: "50px",
                                                            height: "50px",
                                                            borderRadius: "15%",
                                                            border: "2px solid #fff",
                                                        }}
                                                    />
                                                ))}
                                            </div>
                                        ) : (
                                            <p className="fs-18 fw-medium">{item.subtitle}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div id="how-it-works" className="wrapper section-padding bg-soft-zircon">
                <div className="container">
                    <div className="row">
                        <div className="">
                            <div className="mb-8 mb-lg-10">
                                <span className="bg-primary text-white fs-20 fw-bold text-uppercase px-3 py-1 d-inline-block rounded mb-3">
                                    How It Works
                                </span>
                                <h2 className="fs-50 fw-bolder text-mine-shaft mb-0 main-ease-animator1">
                                    Up and running in minutes.
                                </h2>
                            </div>

                            <div className="row gy-6 gy-lg-8">
                                {HowItWorksData.map((item) => (
                                    <div key={item.id} className="col-12">
                                        <div className="d-flex align-items-start gap-4 gap-md-6">
                                            <div
                                                className="bg-soft-primary text-primary fs-20 fw-bolder d-flex align-items-center justify-content-center flex-shrink-0"
                                                style={{ width: "45px", height: "45px", borderRadius: "50%" }}
                                            >
                                                {item.id}
                                            </div>
                                            <div>
                                                <h3 className="fs-22 fw-bolder text-mine-shaft mb-2">{item.title}</h3>
                                                <p className="fs-18 fw-medium text-mine-shaft mb-0">{item.subtitle}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="pricing" className="wrapper section-padding bg-soft-primary">
                <div className="container">
                    <div className="mb-8 mb-lg-10">
                        <span className="bg-primary text-white fs-20 fw-bold text-uppercase px-3 py-1 d-inline-block rounded mb-3">
                            Pricing
                        </span>
                        <h2 className="fs-50 fw-bolder text-mine-shaft mb-3 main-ease-animator1">
                            Start free. Upgrade when you're ready.
                        </h2>
                        <p className="fs-20 fw-medium text-mine-shaft pe-lg-15 main-ease-animator2">
                            Try the app for one full period cycle at no cost. No credit card required.
                        </p>
                    </div>

                    <div className="row g-4 g-lg-5">
                        {PricingData.map((item) => (
                            <div key={item.id} className="col-md-6 col-lg-3">
                                <div
                                    className={`card border-1 h-100 br-24 shadow-sm cursor-pointer transition-all ${selectedPlan === item.id ? 'border-primary' : 'border-light'}`}
                                    style={{
                                        cursor: 'pointer',
                                        border: selectedPlan === item.id ? "2px solid #9CA37F" : "1px solid #dee2e6",
                                        transform: selectedPlan === item.id ? "scale(1.02)" : "scale(1)",
                                        zIndex: selectedPlan === item.id ? "1" : "0"
                                    }}
                                    onClick={() => setSelectedPlan(item.id)}
                                >
                                    <div className="card-body p-6 p-lg-8">
                                        {item.badge && (
                                            <span className="badge bg-soft-primary text-primary fs-12 fw-bold text-uppercase mb-4 px-3 py-2 rounded-pill">
                                                {item.badge}
                                            </span>
                                        )}
                                        <h3 className="fs-24 fw-bolder text-mine-shaft mb-1">{item.title}</h3>
                                        <p className="fs-14 fw-medium text-secondary mb-6">{item.subtitle}</p>

                                        <ul className="list-unstyled mb-0">
                                            {item.features.map((feature, index) => (
                                                <li key={index} className="d-flex align-items-center gap-3 mb-3">
                                                    <span className="text-primary fs-18 fw-bold">✓</span>
                                                    <span className="fs-16 fw-medium text-mine-shaft">{feature}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* <div className="wrapper section-padding " id="sec-app-download">
                <div className="container">
                    <div className="card br-20 bg-soft-primary overflow-hidden">
                        <div className="card-body pb-0 pb-md-0 pb-lg-0 p-md-10 p-lg-12">
                            <div className="row align-items-center gy-10">
                                <div className="col-xl-6 text-xl-start text-center">
                                    <h2 className="fs-50 fw-bolder text-capitalize text-mine-shaft mb-4 mb-lg-5 main-ease-animator1">
                                        Driver, Deliver & Earn on Your Schedule
                                    </h2>
                                    <p className="fs-20 fw-medium text-mine-shaft mb-8 mb-lg-10 main-ease-animator2 ">
                                        Flexible deliveries, reliable earnings. Join our driver network and provide
                                        hassle-free service on your schedule.
                                    </p>
                                    <div className="d-flex flex-wrap justify-content-center justify-content-xl-start gap-3 gap-md-4 mb-5 pb-md-10 pb-lg-12">
                                        <div>
                                            <Link to="#">
                                                <img
                                                    className="img-fluid main-ease-animator3"
                                                    src={GooglePlaySVG}
                                                    width={177}
                                                    height={55}
                                                    alt="Google Play"
                                                />
                                            </Link>
                                            <p className="ms-4 text-primary text-xl-start text-mine-shaft mt-3 mb-0 fs-18 fw-bolder ">
                                                Coming Soon...
                                            </p>
                                        </div>
                                        <div>
                                            <Link to="#">
                                                <img
                                                    className="img-fluid main-ease-animator3"
                                                    src={AppStoreSvg}
                                                    width={165}
                                                    height={55}
                                                    alt="App store"
                                                />
                                            </Link>
                                            <p className="ms-4 text-primary text-xl-start text-mine-shaft mt-3 mb-0 fs-18 fw-bolder">
                                                Coming Soon...
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6 text-center">
                                    <img
                                        className="img-fluid position-xl-absolute top-0 end-0 bottom-0"
                                        src={MobileView}
                                        width={584}
                                        height={461}
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* <div className="wrapper section-padding carbon-credits-sec">
                <div className="container">
                    <div className="col-lg-10 mx-auto text-center mb-6 mb-lg-7">
                        <h2 className="fs-50 fw-bolder text-capitalize text-mine-shaft mb-4 mb-lg-5 main-ease-animator1">
                            Carbon Credits That Reward Smarter Journeys
                        </h2>
                        <p className="fs-24 fw-medium text-mine-shaft mb-0 main-ease-animator2">
                            At Hitch, every delivery helps reduce unnecessary trips on Irish roads. When a driver
                            completes a job that replaces another user’s separate journey, they earn 1 Carbon Credit for
                            every kilometre saved.
                        </p>
                    </div>
                    <div className="row justify-content-center gy-5 gx-lg-10 mb-lg-13">
                        <div className="col-md-6 col-xl-4 d-flex">
                            <div className="card br-20 w-100">
                                <div className="card-body px-lg-6 py-lg-9">
                                    <div className="row align-items-center gy-4">
                                        <div className="col-lg-auto">
                                            <img
                                                className="img-fluid"
                                                src={EmissionSvg}
                                                width={80}
                                                height={80}
                                                alt=""
                                                loading="lazy"
                                            />
                                        </div>
                                        <div className="col-lg">
                                            <p className="fs-18 fw-medium mb-0">
                                                Hitch uses engine size and distance to calculate the emissions saved.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-4 d-flex">
                            <div className="card br-20 w-100">
                                <div className="card-body px-lg-6 py-lg-9">
                                    <div className="row align-items-center gy-4">
                                        <div className="col-lg-auto">
                                            <img
                                                className="img-fluid"
                                                src={CarbonMeterSvg}
                                                width={80}
                                                height={80}
                                                alt=""
                                                loading="lazy"
                                            />
                                        </div>
                                        <div className="col-lg">
                                            <p className="fs-18 fw-medium mb-0">
                                                Drivers automatically earn Carbon Credits for every kilometre they help
                                                to offset.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-4 d-flex">
                            <div className="card br-20 w-100">
                                <div className="card-body px-lg-6 py-lg-9">
                                    <div className="row align-items-center gy-4">
                                        <div className="col-lg-auto">
                                            <img
                                                className="img-fluid"
                                                src={TravelReductionSvg}
                                                width={80}
                                                height={80}
                                                alt=""
                                                loading="lazy"
                                            />
                                        </div>
                                        <div className="col-lg">
                                            <p className="fs-18 fw-medium mb-0">
                                                These credits reflect real, measurable reductions in duplicated travel.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* <div id="about-us" className="wrapper section-padding bg-light-gray">
                <div className="container py-md-6 py-lg-10">
                    <div className="row align-items-center gy-5">
                        <div className="col-lg-6 text-center text-lg-start">
                            <h2 className="fs-50 fw-bolder text-capitalize text-mine-shaft text-center text-lg-start mb-4 mb-lg-5 main-ease-animator1">
                                About Us
                            </h2>
                            <p className="fs-20 fw-medium text-mine-shaft mb-4 mb-lg-5 main-ease-animator2">
                                Hitch is an innovative delivery platform designed to connect customers and drivers
                                seamlessly. Customers can easily post their product delivery requests, and drivers can
                                accept jobs that match their routes saving time, fuel, and effort.
                            </p>
                            <p className="fs-20 fw-medium text-mine-shaft mb-0 main-ease-animator2">
                                Our platform makes every trip more productive while providing customers with fast,
                                affordable, and reliable delivery options. Whether it’s a small parcel or a larger
                                shipment, Hitch ensures smooth and secure transportation with just a few taps.
                            </p>
                            <div className="mt-8 mt-lg-10">
                                <a
                                    href="#sec-app-download"
                                    onClick={(e) => handleScrollToSection(e, "sec-app-download")}
                                    className="btn btn-primary d-inline-flex align-items-center gap-2 px-7 px-md-8 px-lg-11"
                                >
                                    Download Now <img src={ArrowRight} width={20} height={20} alt="" loading="lazy" />{" "}
                                </a>
                            </div>
                        </div>
                        <div className="col-lg-6 text-center order-lg-first">
                            <img className="img-fluid" src={AboutImg} width={540} height={450} alt="" loading="lazy" />
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="wrapper section-padding bg-soft-zircon" id="reviews">
                <div className="container">
                    <h2 className="fs-50 fw-bolder text-center mb-5 main-ease-animator1">
                        Real Stories from Satisfied Customers
                    </h2>
                    <p className="fs-20 fw-medium text-center mb-10 mb-lg-12">
                        See how our customers are happy with their seamless experiences.
                    </p>
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={20}
                        loop={true}
                        autoplay={{
                            delay: 3500,
                            disableOnInteraction: false,
                        }}
                        pagination={{
                            clickable: true,
                        }}
                        breakpoints={{
                            768: {
                                slidesPerView: 1,
                                spaceBetween: 20,
                            },
                            1200: {
                                slidesPerView: 2,
                                spaceBetween: 30,
                            },
                        }}
                        modules={[Autoplay]}
                        className="testimonial-swiper"
                    >
                        {TestimonialData.map((testimonial, idx) => (
                            <SwiperSlide key={testimonial.name}>
                                <div className="card br-20 w-100">
                                    <div className="card-body p-lg-10">
                                        <div className="row align-items-center gy-4">
                                            <div className="col-lg-4 text-center">
                                                <img
                                                    className="img-fluid rounded-circle mb-4"
                                                    src={testimonial.image}
                                                    width={120}
                                                    height={120}
                                                    alt={testimonial.name}
                                                    loading="lazy"
                                                />
                                                <h3 className="fs-30 fw-fw-bold mb-0">{testimonial.name}</h3>
                                            </div>
                                            <div className="col-lg text-lg-start text-center">
                                                <div className="d-flex align-items-center justify-content-center justify-content-lg-start gap-1 mb-5 mb-lg-6">
                                                    {[...Array(testimonial.rating)].map((_, i) => (
                                                        <img key={i} src={StarIcon} width={24} height={24} alt="star" />
                                                    ))}
                                                </div>
                                                <p className="fs-18 fw-medium mb-0">{testimonial.review}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
            {/* <div className="wrapper section-padding bg-soft-primary">
                <div className="container">
                    <h2 className="fs-50 fw-bolder text-center mb-5 main-ease-animator1 col-xl-9 mx-auto">
                        Winner of Sustainability & Green Award at Donegal LEO Awards 2025
                    </h2>
                </div>
            </div> */}
            <div id="faq" className="wrapper section-padding bg-soft-primary">
                <div className="container">
                    <div className="row gy-5">
                        <div className="col-lg-5">
                            <h2 className="fs-50 fw-bolder text-center text-lg-start mb-5 main-ease-animator1">
                                <span className="underline-3 style-3 green">Frequently</span> <br className="br" />{" "}
                                Asked Questions
                            </h2>
                            <p className="fs-20 fw-normal text-mine-shaft text-center text-lg-start">
                                Clear answers to the most common questions about <br /> FeedMyCycle and how our app can support you.{" "}
                            </p>
                        </div>
                        <div className="col-lg-7 ">
                            <div className="max-h-lg-475px br-30">
                                <div className="accordion-wrapper card border-dark-gray br-30 overflow-hidden" id="accordion-faqs">
                                    {renderFAQItems(faqs, "faqs")}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div id="contact-us" className="wrapper section-padding position-relative bg-soft-zircon contact-us-sec z-0">
                <div className="">
                    <div className="container">
                        <div className="row align-items-center gy-8 gx-xl-14">
                            <div className="col-lg-6">
                                <img
                                    className="img-fluid mb-8 mb-md-9  mb-lg-11"
                                    src={ChatIcon}
                                    width={86}
                                    height={86}
                                    alt=""
                                    loading="lazy"
                                />
                                <h2 className="fs-50 fw-bolder text-dark mb-3 main-ease-animator1">
                                    Let’s <span className="underline-3 style-3 green">Connect</span>
                                </h2>
                                <p className="fs-22 fw-medium text-dark mb-8 mb-md-10 mb-lg-12">
                                    We’d love to hear from you! If you have any questions, suggestions, or feedback,
                                    please reach out to us.
                                </p>
                                <div className="d-flex align-items-center gap-3">
                                    <img
                                        className="img-fluid flex-shrink-0"
                                        src={Mail}
                                        width={46}
                                        height={46}
                                        alt=""
                                        loading="lazy"
                                    />
                                    <Link
                                        to="mailto:support@feedmycycle.com"
                                        className="fs-22 fw-normal text-mine-shaft"
                                    >
                                        support@feedmycycle.com
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="card bg-primary br-30">
                                    <div className="card-body p-md-7 p-lg-10">
                                        <Form onSubmit={handleSubmit} noValidate>
                                            <div className="row gy-4 gy-lg-7">
                                                <div className="col-12">
                                                    <Form.Group controlId="footerContactName">
                                                        <Form.Label className="text-white">Name</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            className={clsx(
                                                                "form-control bg-white",
                                                                validationErrors.name ? "border-danger" : ""
                                                            )}
                                                            placeholder="John Doe"
                                                            onChange={(e) => handleInputChange(e.target.value, "name")}
                                                            disabled={loading}
                                                            value={formData.name}
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group controlId="footerContactEmail">
                                                        <Form.Label className="text-white">Email</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            className={clsx(
                                                                "form-control bg-white",
                                                                validationErrors.email ? "border-danger" : ""
                                                            )}
                                                            placeholder="john@mail.com"
                                                            onChange={(e) => handleInputChange(e.target.value, "email")}
                                                            disabled={loading}
                                                            value={formData.email}
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-12">
                                                    <Form.Group controlId="footerContactMessage">
                                                        <Form.Label className="text-white">Message</Form.Label>
                                                        <Form.Control
                                                            as="textarea"
                                                            rows={4}
                                                            className={clsx(
                                                                "form-control bg-white",
                                                                validationErrors.message ? "border-danger" : ""
                                                            )}
                                                            placeholder="Hello there"
                                                            onChange={(e) =>
                                                                handleInputChange(e.target.value, "message")
                                                            }
                                                            disabled={loading}
                                                            value={formData.message}
                                                        />
                                                    </Form.Group>
                                                </div>
                                                {/* <div className="col-12">
                                                    <div ref={recaptchaRef}></div>
                                                </div> */}
                                                <div className="col-12 mt-7">
                                                    <Button
                                                        type="submit"
                                                        className="btn btn-white py-lg-7 w-100"
                                                        disabled={loading}
                                                    >
                                                        Submit
                                                    </Button>
                                                </div>
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Home;
